import { render, staticRenderFns } from "./DataVizPlugin.vue?vue&type=template&id=2f230606&scoped=true"
import script from "./DataVizPlugin.vue?vue&type=script&lang=ts"
export * from "./DataVizPlugin.vue?vue&type=script&lang=ts"
import style0 from "./DataVizPlugin.vue?vue&type=style&index=0&id=2f230606&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f230606",
  null
  
)

export default component.exports